// Показ с задержкой: загрузка видна, только если ожидание дольше 0,3 с (FR-040а).
import { useEffect, useState } from 'react';

export const LOADING_DELAY_MS = 300;

/** true, когда active держится дольше delay; сбрасывается сразу, как только active = false. */
export function useDelayedFlag(active: boolean, delay: number = LOADING_DELAY_MS): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setTimeout(() => setShown(true), delay);
    return () => {
      window.clearTimeout(timer);
      setShown(false);
    };
  }, [active, delay]);
  return active && shown;
}
